import { BaseActionObject, StateNodeConfig, assign } from "xstate4"
import isEqual from "lodash/isEqual"
import { Context, LoadableSchema, Transitions } from "../../../types"
import { getProgressByStudyPlanSubjectsTransition } from "../../transitionalStates"

export const spv2ProgressState: StateNodeConfig<
  Context,
  LoadableSchema,
  Transitions,
  BaseActionObject
> = {
  id: "sp_v2_progress_state",
  initial: "loading",
  states: {
    loading: { ...getProgressByStudyPlanSubjectsTransition },

    idle: {
      on: {
        UPDATE_REPORTING_FILTERS_STATE: {
          target: "loading",
          actions: assign<
            Context,
            Extract<Transitions, { type: "UPDATE_REPORTING_FILTERS_STATE" }>
          >((_ctx, evt) => ({
            reportingFiltersState: evt.state
          })),
          cond: (ctx, evt) => !isEqual(ctx.reportingFiltersState, evt.state)
        }
      }
    }
  }
}
